// extracted by mini-css-extract-plugin
export default {"page":"DX-z","cartModal":"EX-z","checkout":"FX-z","placeholder":"GX-z","account":"HX-z"};